import React from 'react'
import { Dropdown } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { useCommunity } from '~/contexts/CommunityContext'

type EventDropdownItemsProps = {
  eventId: string
  onDelete?: (e?: React.MouseEvent) => void
  onClickEdit?: (e?: React.MouseEvent) => void
  onClickRepost?: (e?: React.MouseEvent) => void
  onClickCopy?: (e?: React.MouseEvent) => void
  canRepost?: boolean
  canEdit?: boolean
  canDelete?: boolean
  isRepost?: boolean
  isDraft: boolean
  showLivestreamToggle?: boolean
  livestreamStarted?: boolean
  canToggleLivestream?: boolean
  canSeeLivestreamSettings?: boolean
  toggleLivestream?: () => void
  showLivestreamSettings?: () => void
  inSingleEventView?: boolean
}
export const EventDropdownItems = ({
  onDelete,
  onClickEdit,
  onClickRepost,
  onClickCopy,
  canRepost,
  canEdit,
  canDelete,
  isDraft,
  isRepost,
  livestreamStarted,
  canToggleLivestream,
  toggleLivestream,
  showLivestreamSettings,
  canSeeLivestreamSettings,
  eventId,
  inSingleEventView,
}: EventDropdownItemsProps) => {
  const { communityId, companyId } = useCommunity()

  const singleEventPath = companyId
    ? `/companies/${companyId}/events/${eventId}`
    : `/communities/${communityId}/events/${eventId}`

  return (
    <>
      <Dropdown.Menu className={'event-dropdown-menu'}>
        {!inSingleEventView && (
          <Dropdown.Item className={'view'} as={Link} to={singleEventPath}>
            View as single event
          </Dropdown.Item>
        )}
        <Dropdown.Item className={'copy-link'} onClick={onClickCopy}>
          Copy link to event
        </Dropdown.Item>
        {canEdit && (
          <Dropdown.Item className={'edit'} onClick={onClickEdit}>
            {isDraft ? 'Edit draft' : 'Edit'}
          </Dropdown.Item>
        )}
        {canDelete && (
          <Dropdown.Item className={'delete'} onClick={onDelete}>
            {isRepost ? 'Delete Repost' : isDraft ? 'Delete draft' : 'Delete'}
          </Dropdown.Item>
        )}
        {canRepost && (
          <Dropdown.Item className={'repost'} onClick={onClickRepost}>
            Repost
          </Dropdown.Item>
        )}
        {canToggleLivestream && (
          <Dropdown.Item className={livestreamStarted ? 'toggle-stop' : 'toggle-start'} onClick={toggleLivestream}>
            {livestreamStarted ? 'Stop live stream' : 'Start live stream'}
          </Dropdown.Item>
        )}
        {canSeeLivestreamSettings && (
          <Dropdown.Item className={'edit'} onClick={showLivestreamSettings}>
            Show Livestream Settings
          </Dropdown.Item>
        )}
      </Dropdown.Menu>
    </>
  )
}
